import { Form } from "generated/graphql";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "redux/hooks";
import { selectCase } from "redux/slices/case";
import { selectForm } from "redux/slices/form.slice";
import CaseForm from "../CaseForm";
import { createPortal } from "react-dom";
import { CaseDetailGroup } from "components/CaseDetailGroup";
import { useParamNumbers } from "helpers/hooks/useParamNumbers";
import { PortalContext } from "contexts/PortalContext";
import SBRCaseForm from "SBR/CaseForm";
import { useShowSBR } from "SBR/useShowSBR";

const CaseProfileRoute = () => {
  const { caseId, lensId } = useParamNumbers(["caseId", "lensId"]);
  const navigate = useNavigate();
  const lensCase = useAppSelector(selectCase);
  const form: Form | undefined = useAppSelector(selectForm);
  const { portalRefElement } = useContext(PortalContext);
  const showSbr = useShowSBR();
  if (lensId === undefined || caseId === undefined) {
    navigate("../");
    return null;
  }

  return (
    <>
      {portalRefElement && createPortal(<CaseDetailGroup myCase={lensCase} />, portalRefElement)}
      <div className="min-h-0 h-full flex min-w-0">
        {form !== undefined && showSbr && <SBRCaseForm lensId={lensId} caseId={caseId} lensCase={lensCase} />}
        {form !== undefined && !showSbr && <CaseForm lensId={lensId} caseId={caseId} lensCase={lensCase} />}
      </div>
    </>
  );
};

export default CaseProfileRoute;
